__webpack_require__.p = "/react-mini-projects/";